import { Header, Content } from '@/components'
import { HEADER_HEIGHT } from '@/constants/style'
import useStore from '@/store'
import { LayoutProps } from '@/store/types'

function HomeLayout( props: HomeLayoutProps ) {
    const {
        contentWidth,
        children,
    } = props

    const { isLogin } = useStore()

    return (
        <div className="h100p">
            <Header/>
            <Content
                contentWidth={ 100 }
                mainHeight={ `calc( 100% - ${HEADER_HEIGHT})` }
                contentHeight="100%"
            >
                { children && children }
            </Content>
        </div>
    )
}

export default HomeLayout

export interface HomeLayoutProps extends LayoutProps {
    contentWidth?: number
}
